;(function () {
  'use strict'

  angular
    .module('contrast.org-stats')
    .factory('OrgStatsFactory', ['$http', 'UserService', OrgStatsFactory])

  function OrgStatsFactory($http, UserService) {
    var BASE_URL = '/organizations/stats/'

    return {
      getLicenseStats: getLicenseStats,
      getLicenseHistory: getLicenseHistory,
      getAppStats: getAppStats,
      getAppStatsBreakdown: getAppStatsBreakdown,
      getAppStatsDrilldown: getAppStatsDrilldown,
      getServerStats: getServerStats,
      getServerStatsBreakdown: getServerStatsBreakdown
    }

    function getLicenseStats() {
      return $http.get(UserService.buildAPIUrl(BASE_URL + 'licenses'))
    }

    function getLicenseHistory() {
      return $http.get(UserService.buildAPIUrl(BASE_URL + 'licenses/history'))
    }

    function getAppStats(expand) {
      return $http.get(UserService.buildAPIUrl(BASE_URL + 'application'), {
        params: {
          expand: expand
        }
      })
    }

    function getAppStatsBreakdown(expand, quickFilter) {
      return $http.get(
        UserService.buildAPIUrl(BASE_URL + 'applications/breakdown'),
        {
          params: {
            expand: expand,
            quickFilter: quickFilter
          }
        }
      )
    }

    function getAppStatsDrilldown(quickFilter) {
      return $http.get(
        UserService.buildAPIUrl(BASE_URL + 'applications/drilldown'),
        {
          params: {
            quickFilter: quickFilter
          }
        }
      )
    }

    function getServerStats(expand, quickFilter, limit) {
      return $http.get(UserService.buildAPIUrl(BASE_URL + 'server'), {
        params: {
          expand: expand,
          quickFilter: quickFilter,
          limit: limit
        }
      })
    }

    function getServerStatsBreakdown(expand, quickFilter, environment) {
      return $http.get(
        UserService.buildAPIUrl(BASE_URL + 'servers/breakdown'),
        {
          params: {
            expand: expand,
            quickFilter: quickFilter,
            environment: environment
          }
        }
      )
    }
  }
})()
